import { render, staticRenderFns } from "./WorkOvertime.vue?vue&type=template&id=5045fef9&scoped=true&"
import script from "./WorkOvertime.vue?vue&type=script&lang=js&"
export * from "./WorkOvertime.vue?vue&type=script&lang=js&"
import style0 from "./WorkOvertime.vue?vue&type=style&index=0&id=5045fef9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5045fef9",
  null
  
)

export default component.exports